import React from "react"

import Layout from "../components/Layout/Layout"

import GenerelleRapporterApp from "../components/GeneriskeRapporter"
import { ErrorBoundary } from "react-error-boundary"

const IndexPage = ({ location }: { location: Location }) => (
  <Layout location={location}>
    <ErrorBoundary
      fallbackRender={({ error }) => {
        return <div>{error}</div>
      }}
    >
      <GenerelleRapporterApp />
    </ErrorBoundary>
  </Layout>
)

export default IndexPage
